
export default {
  name: 'AppColorChip',
  props: {
    name: { type: String, required: true },
    color: { type: String, required: true }
  },
  computed: {
    isColorDark() {
      const threshold = parseInt(255 / 2);
      let rgbArray = [];

      if (this.color.includes('rgba')) {
        rgbArray = this.rgba2rgbArray();
      } else if (this.color.includes('#')) {
        const result = this.color.match(/#(.{2})(.{2})(.{2})/);
        const r = result[1];
        const g = result[2];
        const b = result[3];
        rgbArray = [r, g, b].map(v => parseInt(v, 16));
      } else {
        return false;
      }

      return rgbArray.some(v => v < threshold);
    }
  },
  methods: {
    rgba2rgbArray() {
      const result = this.color.match(/(\d+),(\d+),(\d+),(.*)\)/);
      const r = result[1];
      const g = result[2];
      const b = result[3];
      const alpha = result[4];

      return [
        parseInt((1 - alpha) * 255 + alpha * r),
        parseInt((1 - alpha) * 255 + alpha * g),
        parseInt((1 - alpha) * 255 + alpha * b)
      ];
    }
  }
};
